import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchData } from "./config";
import { ErrorType } from "./errorType";
import { roles } from "./roles_skills";
// import { version } from "../../package.json";

export interface Employeetwo {
  employee_code: string;
  full_name: string;
  company: string;
  department_code: string | null;
  department: string | null;
  division_brand: string;
  location_code: string;
  location: string;
  job_code: string;
  job: string;
  active: number;
  id_user: number;
  created_at: string | null;
  updated_at: string | null;
  first_name: string;
  last_name: string;
  title: string;
  city: string;
  state: string;
  zip_code: string;
  district: string;
  vp: string;
  work_phone: string;
  work_extension: string;
  customer_phone: string;
  dm_name: string;
  email_address: string;
  mobile_phone: string;
  location_address1: string;
  location_address2: string | null;
  org_level_2: string;
  org_level_2_code: string;
  org_level_3_code: string;
  org_level_4_code: string;
  company_code: string;
  supervisor_email_address: string;
  supervisor_name: string;
  id_encrypted: string;
}

export interface Employee {
  id: number;
  name: string;
  status: number;
  email: string;
  last_login: string;
  id_encrypted: string;
  extra: {
    phone: string | null;
    avatar: string | null;
    linkedin: string | null;
    facebook: string | null;
    instagram: string | null;
    twitter: string | null;
    gender: string;
    title: string | null;
    address: string | null;
    address_2: string | null;
    email_alternative: string | null;
    employee_ext: string | null;
    employee_suit: string | null;
    employee_city: string | null;
    employee_state: string | null;
    employee_zip_code: string | null;
  };
  employee: {
    employee_code: string;
    full_name: string;
    company: string;
    division_brand: string;
    title: string;
    city: string;
    state: string;
    zip_code: string;
    work_phone: string;
    work_extension: string;
    location_address1: string;
    location_address2: string;
  };
  brands: Brands[];
  roles: roles[];
}
interface EmployeeState {
  employees: Employee[];
  detailEmployee: Employee | null;
  detailEmployeeRoles: roles[];

  current_page: number;
  next_page_url: string | null;
  prev_page_url: string | null;
  from: number;
  to: number;
  status: string;
  errorMessage: string;
  data?: string | null;
  errorType: ErrorType | null;
  total: number;
  per_page: number;
}

export interface Brands {
  name: string;
  pin_logo: string;
  id_encrypted: string;
}

interface Pagination {
  page: number;
  search?: string;
  per_page?: number;
}
export const getEmployees = createAsyncThunk<any, Pagination>(
  "get/employees",
  async ({ page, search, per_page = 10 }) => {
    if (search !== undefined) {
      const response = await fetchData().get(
        `/api/employees/intranet/users?rows=${per_page}&page=${page}&search_full=${search}&order=DESC`,
      );
      return response?.data.data;
    } else {
      const response = await fetchData().get(
        `/api/employees/intranet/users?rows=${per_page}&page=${page}&order=DESC`,
      );
      return response.data.data;
    }
  },
);

interface Propsdetail {
  id_encrypted: string;
}
export const getDetailEmployee = createAsyncThunk<any, Propsdetail>(
  "get/detail/employee",
  async ({ id_encrypted }) => {
    const response = await fetchData().get(
      `/api/employees/intranet/users/${id_encrypted}`,
    );
    return response.data;
  },
);

interface PropsChange {
  status: number;
  id_encrypted: string;
}
export const changeEmployee = createAsyncThunk<any, PropsChange>(
  "change/status/employee",
  async ({ status, id_encrypted }) => {
    const response = await fetchData().put(
      `/api/employees/intranet/users/${id_encrypted}/status`,
      { status },
    );
    return response.data;
  },
);

interface PropsUpdate {
  send: any;
  id_encrypted: string;
}

export const updateEmployee = createAsyncThunk<any, PropsUpdate>(
  "update/employee",
  async (data) => {
    const { send, id_encrypted } = data;
    const response = await fetchData().put(
      `/api/employees/intranet/users/${id_encrypted}`,
      send,
    );
    return response.data;
  },
);

interface PropsSend {
  id_encrypted: string;
}

export const resendInviteEmployee = createAsyncThunk<any, PropsSend>(
  "resendInvite/employee",
  async (data) => {
    const { id_encrypted } = data;
    const response = await fetchData().post(
      `/api/guardian/invite-resend/user/${id_encrypted}`,
    );
    return response.data;
  },
);

export const importEmployees = createAsyncThunk<any, any>(
  "import/employee",
  async (data) => {
    const formData = new FormData();
    formData.append("import_relations_users", data);

    const response = await fetchData()
      .post("/api/guardian/import/relations_brands_insurances", formData)
      .then((response) => {
        const dataResponse = response;
        return dataResponse;
      })
      .catch(({ response }) => {
        // console.log(response);
        return response;
      });
    return response.data;
  },
);

export const assingBrand = createAsyncThunk<any, any>(
  "assingBrand/employee",
  async (data) => {
    const response = await fetchData().post("/api/guardian/user_brands", data);
    return response.data;
  },
);

interface RolesAssing {
  id_user: string;
  id_role: any;
}

export const assingRoles = createAsyncThunk<any, RolesAssing>(
  "assingRoles/employee",
  async (data) => {
    const response = await fetchData().post("/api/guardian/user_roles", data);
    return response.data;
  },
);

interface EmployeeRoles {
  id_encrypted: string;
}

export const getEmployeeRoles = createAsyncThunk<any, EmployeeRoles>(
  "getEmployeeRoles/employee",
  async (data) => {
    const { id_encrypted } = data;
    const response = await fetchData().get(
      `/api/guardian/users/${id_encrypted}`,
    );
    return response.data;
  },
);

const initialState: EmployeeState = {
  total: 0,
  per_page: 0,
  employees: [],
  detailEmployee: null,
  detailEmployeeRoles: [],
  prev_page_url: null,
  current_page: 1,
  next_page_url: null,
  from: 0,
  to: 0,
  status: "",
  errorMessage: "string",
  errorType: null,
  data: null,
};

const employeeSlice = createSlice({
  name: "employee",
  initialState,
  reducers: {
    resetEmployeeStatus: (state) => {
      state.status = "";
    },
  },
  extraReducers: (builder) => {
    /* Login step one */
    builder.addCase(getEmployees.pending, (state) => {
      state.status = "getEmployees_loading";
    });
    builder.addCase(getEmployees.fulfilled, (state, { payload }) => {
      state.employees = payload.data;
      state.current_page = payload.current_page;
      state.from = payload.from;
      state.to = payload.to;
      state.next_page_url = payload.next_page_url;
      state.prev_page_url = payload.prev_page_url;
      state.total = payload.total;
      state.per_page = payload.per_page;
      state.status = "getEmployees_success";
    });
    builder.addCase(getEmployees.rejected, (state, { error }) => {
      state.status = "getEmployees_rejected";
    });
    builder.addCase(getDetailEmployee.pending, (state) => {
      state.status = "getDetailEmployee_loading";
    });
    builder.addCase(getDetailEmployee.fulfilled, (state, { payload }) => {
      state.detailEmployee = payload.data;
      state.status = "getDetailEmployee_success";
    });
    builder.addCase(getDetailEmployee.rejected, (state, { error }) => {
      state.status = "getDetailEmployee_rejected";
    });
    builder.addCase(changeEmployee.pending, (state) => {
      state.status = "changeEmployee_loading";
    });
    builder.addCase(changeEmployee.fulfilled, (state, { payload }) => {
      const filter_employee = state.employees.filter(
        (employee) => employee.id_encrypted !== payload.data.id_encrypted,
      );
      const employees_change = [payload.data, ...filter_employee];
      state.employees = employees_change;
      state.status = "changeEmployee_success";
    });
    builder.addCase(changeEmployee.rejected, (state, { error }) => {
      state.status = "changeEmployee_rejected";
    });
    builder.addCase(updateEmployee.pending, (state) => {
      state.status = "updateEmployee_loading";
    });
    builder.addCase(updateEmployee.fulfilled, (state, { payload }) => {
      state.status = "updateEmployee_success";
    });
    builder.addCase(updateEmployee.rejected, (state, { error }) => {
      state.status = "updateEmployee_rejected";
    });
    builder.addCase(resendInviteEmployee.pending, (state) => {
      state.status = "resendInvite_loading";
    });
    builder.addCase(resendInviteEmployee.fulfilled, (state) => {
      state.status = "resendInvite_success";
    });
    builder.addCase(resendInviteEmployee.rejected, (state) => {
      state.status = "resendInvite_rejected";
    });
    builder.addCase(importEmployees.pending, (state) => {
      state.status = "importEmployees_loading";
    });
    builder.addCase(importEmployees.fulfilled, (state, { payload }) => {
      if (payload.status) {
        state.status = "importEmployees_success";
      } else {
        state.status = "importEmployees_rejected";
        state.errorMessage = payload.error;
        state.data = payload.data;
      }
    });
    builder.addCase(importEmployees.rejected, (state, { error }) => {
      state.status = "importEmployees_rejected";
    });
    builder.addCase(assingBrand.pending, (state) => {
      state.status = "assingBrands_loading";
    });
    builder.addCase(assingBrand.fulfilled, (state) => {
      state.status = "assingBrands_success";
    });
    builder.addCase(assingBrand.rejected, (state) => {
      state.status = "assingBrands_rejected";
    });
    builder.addCase(assingRoles.pending, (state) => {
      state.status = "assingRoles_loading";
    });
    builder.addCase(assingRoles.fulfilled, (state) => {
      state.status = "assingRoles_success";
    });
    builder.addCase(assingRoles.rejected, (state) => {
      state.status = "assingRoles_rejected";
    });
    builder.addCase(getEmployeeRoles.pending, (state) => {
      state.status = "getEmployeeRoles_loading";
    });
    builder.addCase(getEmployeeRoles.fulfilled, (state, { payload }) => {
      state.status = "getEmployeeRoles_success";
      state.detailEmployeeRoles = payload.data.roles;
    });
    builder.addCase(getEmployeeRoles.rejected, (state) => {
      state.status = "getEmployeeRoles_rejected";
    });
  },
});
export const { resetEmployeeStatus } = employeeSlice.actions;
export default employeeSlice.reducer;
